import * as yup from "yup"

yup.setLocale({
  string: {
    email: "Ungültige Adresse"
  },
  mixed: {
    required: "Pflichtfeld"
  }
})

export default yup
